import React from "react";

import styles from './Modal.module.css';
import DOMPurify from "dompurify";

const OfferDetailsContent = ({ offerData }) => {
  return (
    <>
      <p className = { styles.modalParagraph }>
        {offerData?.description ? (
          <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(offerData.description, { USE_PROFILES: { html: true } }) }} />
        ) : (
          "[ NO DETAIL DESCRIPTION ]"
        )}
      </p>

      <h3 className = { styles.modalSectionTitle }>NEED TO KNOW</h3>

      <ul className = { styles.modalList }>
        <li>Select resorts in US, Canada, Caribbean & LATAM only</li>
        <li>Promotional code: {offerData?.clusterCode || "[ NO CODE ]"}</li>
        <li>
          Valid stay dates: {offerData?.stayStartDate || "[ NO START DATE ]"} -{" "}
          {offerData?.stayEndDate || "[ NO END DATE ]"}
        </li>
        <li>
          Book by: {offerData?.bookingEndDate || "[ NO BOOKING END DATE ]"}
        </li>
      </ul>

      <h3 className = { styles.modalSectionTitle }>HOW TO BOOK</h3>

      <p className = { styles.modalParagraph }>
        Be sure that the Promotional Code appears in the Corporate/Promotional
        code box when making your online reservation, or call 1-800-228-9290 and
        ask for the promotional code. For toll-free numbers outside the US
        please visit{" "}
        <a href="#" className = { styles.modalLink }>
          Global Reservation Numbers
        </a>
      </p>

      <h3 className = { styles.modalSectionTitle }>TERMS AND CONDITIONS</h3>

      <p className = { styles.modalParagraph }>
        {offerData?.termsAndConditions || "[ NO TERMS AND CONDITIONS ]"}
      </p>
    </>
  );
};

export default OfferDetailsContent;
